module.exports = __webpack_public_path__ + "static/media/assessment-footer-bg.d2b3be66.png";